'use client'

import { cn } from '@/utilities/ui'
import React, { useEffect, useRef, useState } from 'react'
import { motion } from 'motion/react'

import type { Props as MediaProps } from '../types'

import { getMediaUrl } from '@/utilities/getMediaUrl'

const PlayIcon = () => (
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="40" cy="40" r="39" stroke="#FDE047" strokeWidth="2" />
    <path d="M53 40L35.75 50.3923L35.75 29.6077L53 40Z" fill="#FDE047" />
  </svg>
)

export const VideoMedia: React.FC<MediaProps> = (props) => {
  const { onClick, resource, videoClassName } = props
  const [isPlaying, setIsPlaying] = useState(false)
  const videoRef = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    const { current: video } = videoRef
    if (video) {
      video.addEventListener('suspend', () => {
        // setShowFallback(true);
        // console.warn('Video was suspended, rendering fallback image.')
      })
    }
  }, [])

  const handlePlay = () => {
    setIsPlaying(true)
    if (videoRef.current) {
      videoRef.current.play()
    }
  }

  if (resource && typeof resource === 'object') {
    const { url } = resource
    const cacheTag = resource.updatedAt

    return (
      <div className="relative aspect-video cursor-pointer" onClick={handlePlay}>
        {!isPlaying ? (
          <>
            {/* Show thumbnail or first frame */}
            <video
              className={cn(videoClassName)}
              muted
              playsInline
              ref={videoRef}
              preload="metadata"
            >
              <source src={getMediaUrl(url, cacheTag)} />
            </video>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="flex items-center justify-center p-4">
                <motion.div
                  whileHover={{ scale: 1.15 }}
                  transition={{ stiffness: 400, damping: 10 }}
                  className="rounded-full bg-gray-500/50 backdrop-blur-sm"
                >
                  <PlayIcon />
                </motion.div>
              </div>
            </div>
          </>
        ) : (
          <video className={cn(videoClassName)} controls autoPlay playsInline ref={videoRef}>
            <source src={getMediaUrl(url, cacheTag)} />
          </video>
        )}
      </div>
    )
  }

  return null
}
